export const OPEN_SIGNUP_MODAL = "OPEN_SIGNUP_MODAL";
export const CLOSE_SIGNUP_MODAL = "CLOSE_SIGNUP_MODAL";

export const OPEN_PAYMENT_ISSUE_MODAL = "OPEN_PAYMENT_ISSUE_MODAL";
export const CLOSE_PAYMENT_ISSUE_MODAL = "CLOSE_PAYMENT_ISSUE_MODAL";

export const SEND_TEST_DAILY_MAIL_REQUEST = "SEND_TEST_DAILY_MAIL_REQUEST";
export const SEND_TEST_DAILY_MAIL_SUCCESS = "SEND_TEST_DAILY_MAIL_SUCCESS";
export const SEND_TEST_DAILY_MAIL_FAIL = "SEND_TEST_DAILY_MAIL_FAIL";
